<template>
  <section id="section2" style="background-color: rgba(229,243,252,0.5); ">
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row align="center" justify="center">
            <v-col cols="12" md="9" xl="9">
              <div class="text-center mt-4">
                <h1 class="section-title font-weight-light">Наши преимущества</h1>
              </div>
            </v-col>
            <v-col cols="12" md="9" xl="9" class="mt-6 mb-6" style="padding-left: 0; padding-right: 0;">
              <v-row>
                <v-col md="3" v-for="(panel, i) in panels" :key="i" :title="panel.text">
                  <v-img :eager="true" :src="panel.img" max-width="100px"
                         class="d-block ml-auto mr-auto"></v-img>
                  <p class="title" v-html="panel.title">
                  </p>
                  <p class="text">
                    {{ panel.text }}
                  </p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
  </section>
</template>

<script>
export default {
  data() {
    return {
      panels: [
        {
          href: "",
          img: require("@/assets/image/pers.png"),
          title: 'Гарантия качества',
          text: "В случае отказа Налоговой мы бесплатно скорректируем документы или вернем вам деньги",
        },
        {
          href: "",
          img: require("@/assets/image/money.png"),
          title: 'Оплата по факту',
          text: "Мы берем оплату только по факту готовности документов.",
        },
        {
          href: "",
          img: require("@/assets/image/consult.png"),
          title: 'Полное <br> сопровождение',
          text: "В случае возникновения сложных ситуаций консультант помогает отстаивать законные интересы.",
        },
        {
          href: "",
          img: require("@/assets/image/securit.png"),
          title: 'Конфиденциальность<br> и безопасность',
          text: "Доступ к вашим данным и финансовой информации есть только у вашего консультанта.",
        }
      ]
    };
  },
};
</script>

<style lang="scss">
#section2{
  .title{
    text-align: center;
    font-size: 16px;
  }
  .text{
    font-size: 15px;
  }
}
</style>
